import React, {useEffect} from "react";
import {
  Text,
  withSitecoreContext,
  RichText,
  Link,
  isEditorActive,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { CardListExtraProps } from "./types/CardListExtra.types";

const CardListExtra = (props: CardListExtraProps) => {
  const CardListExtraArray = props.fields?.List;

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <>
      {CardListExtraArray && (
        <div
          className="CardListExtra__wrapper CardListExtra__wrapper--nobrand"
          id={props?.rendering?.uid}
        >
          {CardListExtraArray.map((item, i) => (
            <div className="CardListExtra CardListExtra--nobrand" key={i}>
              <div className="CardListExtra_image-wrapper solo">
                <div
                  className={`rte-event-list-heading-father ${
                    item.fields?.Icon?.value?.src?.length !== 0 &&
                    item.fields?.Icon?.value?.src?.length !== undefined &&
                    "rte-event-list-heading-father--icon solo"
                  }`}
                >
                  <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left rte-event-list-heading-left-black solo">
                    <img
                      loading="lazy"
                      src={item.fields?.Icon?.value?.src}
                      alt={item.fields?.Icon?.value?.displayName}
                      width="24"
                      height="24"
                      className="PFElement svgicon solo"
                    />
                  </span>
                </div>
              </div>
              <div className="CardListExtra_content CardListExtra__ctn--CardListExtra">
                <div className="CardListExtra_date_content">
                  {item.fields?.Title?.value && (
                    <>
                      {isEditorActive() ? (
                        <Text field={item.fields?.Title} tag="div" />
                      ) : (
                        <Text
                          field={item.fields?.Title}
                          tag="h3"
                          className="CardListExtra__title--CardListExtra"
                          style={{ fontWeight: 500, fontSize: "1.1rem" }}
                        />
                      )}
                    </>
                  )}

                  <RichText
                    field={item?.fields?.SubContent}
                    className="CardListExtra__text"
                  />
                </div>
                <div className="CardListExtra_cta_wrapper">
                  {item?.fields?.["Primary Link"]?.value.href ? (
                    <div className={`cta cta-primary cta-primary-offwhitered`}>
                      {isEditorActive() ? (
                        <div style={{ display: "flex" }}>
                          <Link field={item?.fields?.["Primary Link"]} />
                          <span className="link-with-arrow link-with-arrow--text noclick">
                            <pfe-icon
                              icon="cnh-arrow-forward"
                              size={"24"}
                              color={"complement"}
                            />
                          </span>
                        </div>
                      ) : (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Link field={item?.fields?.["Primary Link"].value} />
                          <span className="link-with-arrow link-with-arrow--text noclick">
                            <pfe-icon
                              icon="cnh-arrow-forward"
                              size={"24"}
                              color={"complement"}
                            />
                          </span>
                        </div>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default withSitecoreContext()(CardListExtra);
